/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './WeSalute-ActionTypes';

const initialState = {
    accessToken: '',
};

const weSaluteReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ACCESS_TOKEN:
            return { ...state, accessToken: action.data };
        case actionTypes.CLEAR_ACCESS_TOKEN:
            return { ...initialState };
        default:
            return state;
    }
};

export default weSaluteReducer;
